<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('trackingPointsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="tracking-point-workspace"
         [class.tracking-point-workspace--loading]="isLoading">
      <mat-card class="tracking-point-panel tracking-point-panel--detail">
        <div class="tracking-point-panel__header">
          <div class="tracking-point-panel__heading">
            <span class="tracking-point-panel__eyebrow">{{ 'trackingPointsCatalog.breadcrumb' | translate }}</span>
            <h3>{{ detailTitle }}</h3>
            <p>{{ detailDescription }}</p>
          </div>
          <div class="tracking-point-panel__actions">
            @if (selectedTrackingPoint && isViewMode) {
              <button mat-stroked-button type="button" class="btn-tone-primary" *appCanAccess="updateAccess" (click)="startEdit()">
                <mat-icon>edit</mat-icon>
                {{ 'common.update' | translate }}
              </button>
              <button mat-stroked-button type="button" class="btn-tone-danger" *appCanAccess="deleteAccess" (click)="deleteSelected()">
                <mat-icon>delete_outline</mat-icon>
                {{ 'common.delete' | translate }}
              </button>
              <button mat-stroked-button type="button" class="btn-tone-neutral" (click)="goBackToList()">
                <mat-icon>arrow_back</mat-icon>
                {{ 'common.back' | translate }}
              </button>
            }
            @if (isCreateMode || isEditMode) {
              <button mat-flat-button type="button" class="btn-tone-primary" (click)="save()" [disabled]="isSaving || !canSave">
                <mat-icon>save</mat-icon>
                {{ isCreateMode ? ('common.create' | translate) : ('common.saveChanges' | translate) }}
              </button>
              <button mat-stroked-button type="button" class="btn-tone-neutral" (click)="cancelEdit()" [disabled]="isSaving">
                <mat-icon>arrow_back</mat-icon>
                {{ 'common.cancel' | translate }}
              </button>
            }
          </div>
        </div>

        <div class="tracking-point-panel__body">
          @if (isCreateMode || isEditMode) {
            <div class="tracking-point-editor">
              <div class="tracking-point-editor__layout">
                <div class="card tracking-point-editor__section mb-0">
                  <div class="card-body">
                    <div class="tracking-point-section-heading">
                      <div class="tracking-point-section-heading__title">
                        <h4>{{ 'trackingPointsCatalog.sections.general' | translate }}</h4>
                        <span class="tracking-point-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                      </div>
                      <p>{{ 'trackingPointsCatalog.sections.generalDescription' | translate }}</p>
                    </div>

                    @if (isCreateMode) {
                      <div class="tracking-point-inline-note mb-3">
                        <mat-icon>info</mat-icon>
                        <span>{{ 'trackingPointsCatalog.detail.createEmployeeHint' | translate }}</span>
                      </div>
                    }

                    <div class="tracking-point-editor__form-grid">
                      <app-date-time-picker-field class="tracking-point-editor__field tracking-point-editor__field--full"
                                                  [label]="'trackingPointsCatalog.fields.trackedAt' | translate"
                                                  [value]="form.trackedAt"
                                                  mode="datetime"
                                                  [disabled]="isSaving"
                                                  (valueChange)="form.trackedAt = $event">
                      </app-date-time-picker-field>

                      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="tracking-point-editor__field">
                        <mat-label>{{ 'trackingPointsCatalog.fields.lat' | translate }}</mat-label>
                        <input matInput type="number" step="0.000001" [(ngModel)]="form.lat" [disabled]="isSaving" (ngModelChange)="onCoordinateInput()">
                      </mat-form-field>

                      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="tracking-point-editor__field">
                        <mat-label>{{ 'trackingPointsCatalog.fields.lng' | translate }}</mat-label>
                        <input matInput type="number" step="0.000001" [(ngModel)]="form.lng" [disabled]="isSaving" (ngModelChange)="onCoordinateInput()">
                      </mat-form-field>

                      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="tracking-point-editor__field">
                        <mat-label>{{ 'trackingPointsCatalog.fields.accuracy' | translate }}</mat-label>
                        <input matInput type="number" step="1" [(ngModel)]="form.accuracy" [disabled]="isSaving">
                      </mat-form-field>

                      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="tracking-point-editor__field">
                        <mat-label>{{ 'trackingPointsCatalog.fields.deviceId' | translate }}</mat-label>
                        <input matInput [(ngModel)]="form.deviceId" [disabled]="isSaving">
                      </mat-form-field>

                      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="tracking-point-editor__field tracking-point-editor__field--full">
                        <mat-label>{{ 'trackingPointsCatalog.fields.deviceVersion' | translate }}</mat-label>
                        <input matInput [(ngModel)]="form.deviceVersion" [disabled]="isSaving">
                      </mat-form-field>

                      @if (!isCreateMode) {
                        <div class="tracking-point-toggle-card tracking-point-editor__field tracking-point-editor__field--full">
                          <div>
                            <strong>{{ 'trackingPointsCatalog.fields.outsideWorkday' | translate }}</strong>
                            <p>{{ 'trackingPointsCatalog.fields.outsideWorkdayHint' | translate }}</p>
                          </div>
                          <mat-slide-toggle [(ngModel)]="form.outsideWorkday" [disabled]="isSaving"></mat-slide-toggle>
                        </div>

                        <div class="tracking-point-toggle-card tracking-point-editor__field tracking-point-editor__field--full">
                          <div>
                            <strong>{{ 'trackingPointsCatalog.fields.isActive' | translate }}</strong>
                            <p>{{ 'trackingPointsCatalog.fields.isActiveHint' | translate }}</p>
                          </div>
                          <mat-slide-toggle [(ngModel)]="form.isActive" [disabled]="isSaving"></mat-slide-toggle>
                        </div>
                      }

                      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="tracking-point-editor__field tracking-point-editor__field--full">
                        <mat-label>{{ 'trackingPointsCatalog.fields.rawPayload' | translate }}</mat-label>
                        <textarea matInput rows="8" [(ngModel)]="form.rawPayloadText" [disabled]="isSaving"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="card tracking-point-editor__section tracking-point-editor__section--map mb-0">
                  <div class="card-body">
                    <div class="tracking-point-section-heading">
                      <div class="tracking-point-section-heading__title">
                        <h4>{{ 'trackingPointsCatalog.sections.map' | translate }}</h4>
                        <span class="tracking-point-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                      </div>
                      <p>{{ 'trackingPointsCatalog.sections.mapDescription' | translate }}</p>
                    </div>

                    <div class="tracking-point-map-toolbar">
                      <div class="tracking-point-map-toolbar__summary">
                        <strong>{{ 'trackingPointsCatalog.fields.coordinates' | translate }}</strong>
                        <span>{{ coordinatesLabel }}</span>
                      </div>
                      <div class="tracking-point-map-toolbar__summary">
                        <strong>{{ 'trackingPointsCatalog.fields.accuracy' | translate }}</strong>
                        <span>{{ form.accuracy !== '' ? form.accuracy : '-' }}</span>
                      </div>
                    </div>

                    <div class="tracking-point-map-shell">
                      <div #pointMap class="tracking-point-map"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          } @else if (selectedTrackingPoint; as point) {
            <div class="tracking-point-detail">
              <div class="card tracking-point-detail__summary mb-0">
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-md-6 col-xl-3">
                      <div class="tracking-point-metric-card"><span>{{ 'trackingPointsCatalog.fields.employeeNumber' | translate }}</span><strong>{{ point.employeeNumber }}</strong></div>
                    </div>
                    <div class="col-md-6 col-xl-3">
                      <div class="tracking-point-metric-card"><span>{{ 'trackingPointsCatalog.fields.employee' | translate }}</span><strong>{{ point.employeeLabel }}</strong></div>
                    </div>
                    <div class="col-md-6 col-xl-3">
                      <div class="tracking-point-metric-card"><span>{{ 'trackingPointsCatalog.fields.trackedAt' | translate }}</span><strong>{{ point.trackedAtLabel }}</strong></div>
                    </div>
                    <div class="col-md-6 col-xl-3">
                      <div class="tracking-point-metric-card"><span>{{ 'trackingPointsCatalog.fields.isActive' | translate }}</span><strong>{{ point.activeLabel }}</strong></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card tracking-point-detail__section-card mb-0">
                <div class="card-body">
                  <div class="tracking-point-section-heading">
                    <h4>{{ 'trackingPointsCatalog.sections.configuration' | translate }}</h4>
                    <p>{{ 'trackingPointsCatalog.sections.configurationDescription' | translate }}</p>
                  </div>

                  <div class="tracking-point-detail__layout">
                    <div class="tracking-point-detail__info-grid">
                      <div class="tracking-point-soft-card"><span>{{ 'trackingPointsCatalog.fields.coordinates' | translate }}</span><strong>{{ point.coordinatesLabel }}</strong></div>
                      <div class="tracking-point-soft-card"><span>{{ 'trackingPointsCatalog.fields.accuracy' | translate }}</span><strong>{{ point.accuracy ?? '-' }}</strong></div>
                      <div class="tracking-point-soft-card"><span>{{ 'trackingPointsCatalog.fields.deviceId' | translate }}</span><strong>{{ point.deviceId || '-' }}</strong></div>
                      <div class="tracking-point-soft-card"><span>{{ 'trackingPointsCatalog.fields.deviceVersion' | translate }}</span><strong>{{ point.deviceVersion || '-' }}</strong></div>
                      <div class="tracking-point-soft-card"><span>{{ 'trackingPointsCatalog.fields.batteryLevel' | translate }}</span><strong class="tracking-battery" [ngClass]="batteryLevelClass"><span class="material-icons" aria-hidden="true">{{ batteryLevelValue !== null && batteryLevelValue <= 15 ? 'battery_alert' : 'battery_std' }}</span>{{ batteryLevelLabel }}</strong></div>
                      <div class="tracking-point-soft-card"><span>{{ 'trackingPointsCatalog.fields.outsideWorkday' | translate }}</span><strong>{{ point.outsideWorkdayLabel }}</strong></div>
                      <div class="tracking-point-soft-card tracking-point-soft-card--full"><span>{{ 'trackingPointsCatalog.fields.rawPayload' | translate }}</span><pre>{{ point.rawPayload | json }}</pre></div>
                    </div>

                    <div class="tracking-point-map-shell tracking-point-map-shell--readonly">
                      <div #pointMap class="tracking-point-map"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="tracking-point-empty">
              <mat-icon>route</mat-icon>
              <h4>{{ 'trackingPointsCatalog.emptyEditorTitle' | translate }}</h4>
              <p>{{ 'trackingPointsCatalog.emptyEditorDescription' | translate }}</p>
            </div>
          }
        </div>
      </mat-card>

      @if (isLoading) {
        <app-loading-state class="tracking-point-loading" [message]="'trackingPointsCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
